import React, { Component }
from 'react';
class ContentLoader extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return(
                <div class="contentLoader">
                    <div class="skeleton">
                        <div class="skeleton-wrapper">
                            <div class="skeleton-wrapper-inner">
                                <div class="skeleton-wrapper-body">
                                    <div class="skeleton-avatar"></div>
                                    <div class="skeleton-author"></div>
                                    <div class="skeleton-label"></div>
                                    <div class="skeleton-content-1"></div>
                                    <div class="skeleton-content-2"></div>
                                    <div class="skeleton-content-3"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="skeleton">
                        <div class="skeleton-wrapper">
                            <div class="skeleton-wrapper-inner">
                                <div class="skeleton-wrapper-body">
                                    <div class="skeleton-avatar"></div>
                                    <div class="skeleton-author"></div>
                                    <div class="skeleton-label"></div>
                                    <div class="skeleton-content-1"></div>
                                    <div class="skeleton-content-2"></div>
                                    <div class="skeleton-content-3"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="skeleton">
                        <div class="skeleton-wrapper">
                            <div class="skeleton-wrapper-inner">
                                <div class="skeleton-wrapper-body">
                                    <div class="skeleton-avatar"></div>
                                    <div class="skeleton-author"></div>
                                    <div class="skeleton-label"></div>
                                    <div class="skeleton-content-1"></div>
                                    <div class="skeleton-content-2"></div>
                                    <div class="skeleton-content-3"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>)
    }
}export default ContentLoader;


// WEBPACK FOOTER //
// ./src/components/bol/contentLoader.js